import { createContext, useContext, useState, useCallback } from 'react';

const BandeauContext = createContext(null);

export function BandeauProvider({ children }) {
    const [override, setOverride] = useState(null); // { title, breadcrumb } | null

    const setBandeau = useCallback((opts) => setOverride(opts), []);
    const resetBandeau = useCallback(() => setOverride(null), []);

    return (
        <BandeauContext.Provider value={{ override, setBandeau, resetBandeau }}>
            {children}
        </BandeauContext.Provider>
    );
}

export function useBandeau() {
    return useContext(BandeauContext);
}
